import { observable } from '@legendapp/state';

interface InteriorStore {
	interiorContainer: HTMLDivElement;
	isInteriorLoaded: boolean;
	isInteriorLoading: boolean;
	currentInterior: [string, string];
	isDragging: boolean;
	isHidden: boolean;
	panRequest: { yaw: number; pitch: number; requestId: number };
}

const createDefaultInteriorContainer = (): HTMLDivElement =>
	typeof document !== 'undefined' ? document.createElement('div') : ({} as HTMLDivElement);

export const interiorStore = observable<InteriorStore>({
	interiorContainer: createDefaultInteriorContainer(),
	isInteriorLoaded: false,
	isInteriorLoading: false,
	currentInterior: ['', ''],
	isDragging: false,
	isHidden: (): boolean => interiorStore.isDragging.get() || interiorStore.isInteriorLoading.get(),
	panRequest: { yaw: 0, pitch: 0, requestId: 0 }
});

export const interiorStoreActions = {
	setIsInteriorLoaded: (bool: boolean) => {
		interiorStore.isInteriorLoaded.set(bool);
	},
	setInteriorData: (data: [string, string]) => {
		interiorStore.currentInterior.set(data);
	},
	requestInteriorPan: (yaw: number, pitch: number) => {
		interiorStore.panRequest.set({ yaw, pitch, requestId: interiorStore.panRequest.requestId.get() + 1 });
	}
};
